export const SHOWALERT = "SHOWALERT";
export const SHOWTOAST = "SHOWTOAST";
export const SHOWALERTCONFIRM = "SHOWALERTCONFIRM";
export const SHOWALERTQUESTION = "SHOWALERTQUESTION";
export const SHOWALERTQUESTIONCONTATO = "SHOWALERTQUESTIONCONTATO";
export const SHOWALERTQUESTIONREASON = "SHOWALERTQUESTIONREASON";
export const SHOWALERTALTERTERM = "SHOWALERTALTERTERM";
